<div class="card" *ngIf="Data">
  <a href="javascript:void(0)" (click)="DirectTo($event)">
    <div class="info">
      <div
        class="favorite {{ Data.favorite ? 'top' : '' }}"
        (click)="FavToggle($event)"
      ></div>
      <div class="status {{ Data.class }}">{{ Data.statusName }}</div>
      <label class="{{ Data.is_new ? 'lasted' : '' }}">
        {{ Data.company_name }}
      </label>
      <p>
        <span class="date">{{ Data.joinDates }}</span>
        <span class="area"
          >{{ Data.country["name"] }}({{ Data.country["continental"] }})</span
        >
        <span class="tag">
          <ng-container *ngFor="let ind of Data.industries">
            <span class="indust">{{ ind.name }}</span>
          </ng-container>
        </span>
      </p>
    </div>
  </a>

  <div class="divider"></div>
  <div class="tags">
    <ng-container *ngFor="let prod of Data.products">
      <p class="prod_intro">
        <!-- <span>{{prod|json}}</span> -->
        <label class="name">{{ prod.name }}</label>
        <label class="intro">
          <ng-container *ngIf="prod.spec_visible == false">
            <ng-container *ngIf="IsLogin && prod.description">
              <i class="icon icon-target">&#xe812;</i>
              {{ prod.description }}
            </ng-container>
            <ng-container *ngIf="!IsLogin">
              <i class="icon icon-target">&#xe812;</i>
              登入查看詳細規格
            </ng-container>
          </ng-container>
          <ng-container *ngIf="prod.spec_visible == true && prod.description">
            <i class="icon icon-target">&#xe812;</i>
            {{ prod.description }}
          </ng-container>
        </label>

        <ng-container>
          <ng-container *ngIf="prod.spec_visible == false">
            <ng-container *ngIf="IsLogin">
              <label
                class="attach"
                *ngIf="prod.hasAttachment"
                (click)="DownloadFile(prod)"
              >
                <i class="icon icon-attach-file">&#xe80a;</i>下載附件
              </label>
            </ng-container>
            <ng-container *ngIf="!IsLogin">
              <label class="attach" (click)="DirectLogin()">
                <i class="icon icon-lock">&#xe80e;</i>立即登入
              </label>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="prod.spec_visible == true">
            <label
              class="attach"
              *ngIf="prod.hasAttachment"
              (click)="DownloadFile(prod)"
            >
              <i class="icon icon-attach-file">&#xe80a;</i>下載附件
            </label>
          </ng-container>
        </ng-container>
      </p>
    </ng-container>

    <!-- <ng-container *ngFor="let prod of Data.products">
            <span [attr.data-desc]="prod.description"
             [attr.data-spec]="prod.spec_visible"
              [attr.data-attach]="prod.hasAttachment"
               [attr.data-pid]="prod.id"
                [attr.data-buyer]="Data.buyer_id">{{prod.name}}</span>
        </ng-container> -->
  </div>
</div>
